module.exports = __webpack_public_path__ + "img/5.31195385.png";